// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__4s1QX","primary":"Button_primary__1_vON","secondary":"Button_secondary__14OBX","small":"Button_small__1pZJa","label":"Button_label__1ShpG"};